// src/features/streams/useStream.ts

import { useQuery } from '@tanstack/react-query';
import { StreamApi } from './StreamApi';
import { MEDIA_QUERY_KEYS } from '@/lib/constants/media';
import { useAuth } from '@/features/auth/hooks/useAuth';

/**
 * Fetch single stream with full detail data.
 */
export function useStream(mediaId: number) {
  const { selectedCId } = useAuth();

  return useQuery({
    queryKey: MEDIA_QUERY_KEYS.stream(selectedCId ?? 0, mediaId),
    queryFn: () => StreamApi.getStream(selectedCId!, mediaId),
    enabled: selectedCId != null && mediaId > 0,
    staleTime: 60 * 1000, // 1 minute
  });
}
